import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import { Route, Switch } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import DomainsList from "./List";
import DomainForm from "./Form";
import Domain from "./View";
import NotFound from "../NotFound";

import { PageHeader } from "../Shared";

import { domainActions } from "./actions/domains.actions";

export class ManageDomains extends Component {
  componentDidMount() {
    this.getDomains();
  }

  getDomains = () => {
    this.props.getDomains();
  };

  render() {
    const { fetching, fetched, response, error, match } = this.props;

    return (
      <div className="Domains">
        <Row>
          <Col>
            <PageHeader pageId="domains" pageTitle="Manage Domains" />
          </Col>
        </Row>

        <div className="content-wrapper">
          <Switch>
            <Route
              exact
              path={match.url}
              render={() => (
                <DomainsList
                  match={match}
                  data={response}
                  loadData={this.getDomains}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route
              path={`${match.url}/list`}
              render={() => (
                <DomainsList
                  match={match}
                  data={response}
                  loadData={this.getDomains}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route path={`${match.url}/add`} component={DomainForm} />
            <Route path={`${match.url}/view/:id`} component={Domain} />
            <Route path={`${match.url}/edit/:id`} component={DomainForm} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, response, error } = state.domains;
  return {
    fetching,
    fetched,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getDomains: bindActionCreators(
      domainActions.getAllDomains,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageDomains);
